import BaseComponent from "../../../baseComponent.js";
import styles from "./header.scss";

export default class DatasetDetailHeader extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let providedBy = "";

    if (this.props.dataset.organizationId == null) {
      providedBy = `provided by ${this.props.dataset.userFirstName} ${this.props.dataset.userLastName}`;
    } else {
      providedBy = `provided by ${this.props.dataset.userFirstName} ${this.props.dataset.userLastName} at ${this.props.dataset.organizationName}`;
    }

    return (
      <div className={styles.header}>
        <div className={styles.content}>
          <div className={styles.name}>
            {this.props.dataset.name}
          </div>
          <div className={styles.provider}>
            {providedBy}
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/header/datasetDetailHeader.jsx